_collow.components.Errorbox = class Errorbox extends _collow.components.Base {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(root.parentElement, "_collow-custom-error", ({ detail }) =>
      this.setErrorBox(detail)
    );
    this.listen(root.parentElement, "_collow-input-change", this.hideErrorbox);
    this.listen(
      root.parentElement,
      "_collow.error-with-input",
      this.setCustomErrorbox
    );
  }

  /** setting errorbox with error code connected to the and has a fallback to in case no error code matches */
  setErrorBox = (err) => {
    Array.from(this.elements).forEach((el) => el.setAttribute("hidden", "")); // set all previous errors hidden
    this.root.removeAttribute("hidden");
    const errorCode = err?.detail?.["error_code"]?.toCamelCase(); // make error name into camel case style
    this.dispatch(this.root, "_collow-errorbox-active");

    if (!errorCode || !this.elements[errorCode]) {
      this.elements.fallBackError.removeAttribute("hidden");
      return;
    }
    this.elements[errorCode].removeAttribute("hidden");
  };

  /** set an custom errorcode dynamicly based. */
  setCustomErrorbox = ({ detail }) => {
    if (detail?.clear) this.root.innerHTML = "";
    this.root.removeAttribute("hidden");
    this.root.insertAdjacentHTML("beforeend", ...detail.err);
  };

  hideErrorbox = () => {
    this.root.setAttribute("hidden", "");
    Array.from(this.elements).forEach((el) => el.setAttribute("hidden", ""));
  };
};
